import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useMutation } from "@tanstack/react-query";

export function useMutateGenerateNewRequest() {
    const { oktaAuth } = useOktaAuth();

    const generateNewRequest = async (requestData) => {
        const accessToken = oktaAuth.getAccessToken();
        
        const requestBody = {
            rpid: requestData.rpid,
            userName: requestData.userName,
            startDate: requestData.startDate.toISOString(),
            endDate: requestData.endDate.toISOString()
        };

        const response = await axios.post(
            `api/ThirdPartyReceivable/CreateNewRequestCall`,
            requestBody,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
            }
        );

        return response.data;
    };

    return useMutation({
        mutationFn: generateNewRequest,
    });
}